<app-auth-shell [testimonial]="false">
  @switch (stage()) {
    @case ('email') {
      <app-auth-header
        [title]="'pages.auth.recovery.title' | transloco"
        [subtitle]="'pages.auth.recovery.subtitle' | transloco" />

      <form [formGroup]="emailForm" (ngSubmit)="sendCode()" novalidate>
        <app-auth-panel>
          <vx-form-field [label]="'pages.auth.recovery.emailLabel' | transloco">
            <vx-input
              size="lg"
              type="email"
              name="email"
              formControlName="email"
              autocomplete="email" />
          </vx-form-field>

          @if (notice() === 'expired') {
            <p class="text-13 tracking-tight text-zinc-400" role="status">
              {{ 'pages.auth.recovery.expired' | transloco }}
            </p>
          }

          @if (notice() === 'failed') {
            <p class="text-13 tracking-tight text-danger-400" role="alert">
              {{ 'pages.auth.recovery.failed' | transloco }}
            </p>
          }

          @if (messages().length) {
            <app-kratos-messages [messages]="messages()" />
          }

          <vx-button
            type="submit"
            size="lg"
            [fullWidth]="true"
            [loading]="step.busy()">
            {{ 'pages.auth.recovery.sendCode' | transloco }}
          </vx-button>
        </app-auth-panel>
      </form>

      <p class="mt-5 text-center text-sm tracking-tight text-zinc-400">
        {{ 'pages.auth.recovery.remembered' | transloco }}
        <a
          class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
          routerLink="/login">
          {{ 'pages.auth.recovery.signIn' | transloco }}
        </a>
      </p>
    }

    @case ('code') {
      <app-auth-header
        [title]="'pages.auth.code.title' | transloco"
        [subtitle]="'pages.auth.code.sentTo' | transloco: { email: email() }" />

      <app-auth-panel class="items-center pt-8">
        <app-code-entry
          [step]="step"
          [messages]="messages()"
          (completed)="submitCode($event)" />
      </app-auth-panel>

      <app-code-resend
        class="mt-5"
        [resendIn]="cooldown.remaining()"
        [busy]="step.busy()"
        (resend)="resend()"
        (changeEmail)="changeEmail()" />
    }

    @case ('password') {
      <app-auth-header
        [title]="'pages.auth.recovery.password.title' | transloco"
        [subtitle]="'pages.auth.recovery.password.subtitle' | transloco" />

      <form [formGroup]="passwordForm" (ngSubmit)="savePassword()" novalidate>
        <app-auth-panel>
          <!-- lets a password manager file the new password under the account -->
          <input
            type="email"
            name="username"
            autocomplete="username"
            class="hidden"
            [value]="email()"
            readonly
            aria-hidden="true"
            tabindex="-1" />

          <vx-form-field
            [label]="'pages.auth.recovery.password.label' | transloco">
            <vx-input
              size="lg"
              type="password"
              name="password"
              formControlName="password"
              autocomplete="new-password"
              [revealLabel]="'pages.auth.recovery.password.show' | transloco" />
          </vx-form-field>

          @if (notice() === 'failed') {
            <p class="text-13 tracking-tight text-danger-400" role="alert">
              {{ 'pages.auth.recovery.failed' | transloco }}
            </p>
          }

          @if (messages().length) {
            <app-kratos-messages [messages]="messages()" />
          }

          <vx-button
            type="submit"
            size="lg"
            [fullWidth]="true"
            [loading]="step.busy()"
            [disabled]="!passwordReady()">
            {{ 'pages.auth.recovery.password.submit' | transloco }}
          </vx-button>
        </app-auth-panel>
      </form>
    }
  }

  <app-auth-help />
</app-auth-shell>
